import './polyfill'
import 'core-js/es'
import 'mutation-observer'
import 'react-app-polyfill/ie9'  
import 'react-app-polyfill/stable'
import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom'
import '@/utils/request.js';
import '@/styles/index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import defaultSetting from './setting'
const htmlClassNames = document.getElementsByTagName('html')[0].className
if (defaultSetting.isSetGray) document.getElementsByTagName('html')[0].className += htmlClassNames.includes('grayStyle') ? '' : ' grayStyle'
else document.getElementsByTagName('html')[0].className = htmlClassNames.includes('grayStyle') ? document.getElementsByTagName('html')[0].removeClass('grayStyle') : htmlClassNames

ReactDOM.render(
  // <React.StrictMode>
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  // </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
